import { Toast } from '@unmind/design-system';
import React, { useEffect, Reducer, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import { basicReducer, IBasicReducerAction } from 'utils';
import { useGetUpcomingEAPAppointments } from 'Book/shared';
import type { getServices_bookableServices } from '../../../Book/hooks';

import { RenderStep } from './components';
import { Form } from './Form.styles';
import { default as initialState } from './state';
import { StyledLoader } from './styles';
import type { IFormState } from './types';

export default ({ service }: { service: getServices_bookableServices }) => {
  const { t } = useTranslation<'book'>('book');
  const { loading, data: appointments } = useGetUpcomingEAPAppointments();

  const typedReducer: Reducer<
    IFormState,
    IBasicReducerAction | IBasicReducerAction[]
  > = basicReducer;
  const [state, dispatch] = useReducer(typedReducer, {
    ...initialState,
    details: {
      ...initialState.details,
      appointmentTypes: service.appointmentTypes,
    },
    service,
  });

  useEffect(() => {
    const upcomingAppointment = appointments?.upcomingAppointments.find(
      appointment => appointment.service?.serviceSlug === service.serviceSlug,
    );

    if (upcomingAppointment) {
      dispatch([
        { type: 'step', value: 5 },
        {
          type: 'details',
          value: {
            appointmentId: upcomingAppointment.id,
            counsellor: {
              firstName: upcomingAppointment.counsellorName,
              lastName: '',
            },
            appointmentMode: upcomingAppointment.mode,
            submittedForm: false,
          },
        },
        {
          type: 'answers.1.appointmentMode',
          value: upcomingAppointment.mode,
        },
        {
          type: 'answers.1.timeZone',
          value: upcomingAppointment.timeZone,
        },
        {
          type: 'answers.2.date',
          value: new Date(upcomingAppointment.dateFrom),
        },
        {
          type: 'answers.4.time',
          value: new Date(upcomingAppointment.dateFrom).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'UTC',
          }),
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service, appointments]);

  if (loading) {
    return <StyledLoader variant="text" text={t('service.form.loading')} />;
  }

  return (
    <Form>
      {state.step < Object.keys(state.answers).length &&
        (service.isScreening ? (
          <h2>{t('service.form.title_initial')}</h2>
        ) : (
          <h2>{t('service.form.title')}</h2>
        ))}
      <RenderStep
        service={state.service}
        step={state.step}
        answers={state.answers}
        errors={state.errors}
        dispatch={dispatch}
        details={state.details}
      />
      <Toast />
    </Form>
  );
};
